module.exports = {
  PROVIDER_CODE: (code) => code.includes('PAYSTACK') ? code : false,
  DISPLAY_NAME: 'Paystack'
}
